export const DISPLAY_AD_MIDDLE_SELECTOR = "#criteo-advert-middle";
export const DISPLAY_AD_BOTTOM_SELECTOR = "#criteo-advert-bottom";
